<!-- src/app/layout/shell.component.html -->
<mat-sidenav-container class="shell-container">
  <div class="loading-overlay" [class.active]="isAppLoading() || isRefreshing()">
    <div class="loading-spinner">
      <mat-spinner diameter="50"></mat-spinner>
      <span class="loading-text">
        {{ isRefreshing() ? ('SIDENAV.REFRESH' | translate) : ('LOADING' | translate) }}
      </span>
    </div>
  </div>

  <mat-sidenav #sidenav mode="over" [opened]="sideNavOpen" class="sidenav" (keydown.escape)="sideNavOpen = false">
    <div class="sidenav-header">
      <h1>{{ 'SIDENAV.TITLE' | translate }}</h1>
      <button mat-icon-button aria-label="Close side navigation" class="close-btn" (click)="sidenav.close()">
        <mat-icon>chevron_left</mat-icon>
      </button>
    </div>

    <div class="sidenav-content">
      <mat-nav-list>
        <a mat-list-item (click)="sidenav.close()" routerLink="/home">
          <mat-icon matListItemIcon>home</mat-icon>
          {{ 'SIDENAV.HOME' | translate }}
        </a>
        <a mat-list-item (click)="sidenav.close()" routerLink="/transaction">
          <mat-icon matListItemIcon
            [matBadge]="getUnreadCount(0) || null"
            matBadgeColor="warn"
            matBadgeSize="small">payment</mat-icon>
          {{ 'SIDENAV.TRANSACTION' | translate }}
        </a>
        <!--<a mat-list-item (click)="sidenav.close()" routerLink="/notifications">
      <mat-icon matListItemIcon>notifications</mat-icon>
      {{ 'SIDENAV.NOTIFICATION' | translate }}
    </a>-->
        <a mat-list-item (click)="sidenav.close()" routerLink="/message">
          <mat-icon matListItemIcon
            [matBadge]="getUnreadCount(1) || null"
            matBadgeColor="warn"
            matBadgeSize="small">message</mat-icon>
          {{ 'SIDENAV.MESSAGES' | translate }}
        </a>
        <a mat-list-item (click)="sidenav.close()" routerLink="/table">
          <mat-icon matListItemIcon
            [matBadge]="getUnreadCount(2) || null"
            matBadgeColor="warn"
            matBadgeSize="small">table_view</mat-icon>
          {{ 'SIDENAV.TABLES' | translate }}
        </a>
        <a mat-list-item (click)="sidenav.close()" routerLink="/chart">
          <mat-icon matListItemIcon
            [matBadge]="getUnreadCount(3) || null"
            matBadgeColor="warn"
            matBadgeSize="small">bar_chart</mat-icon>
          {{ 'SIDENAV.CHARTS' | translate }}
        </a>
        <a mat-list-item (click)="sidenav.close()" routerLink="/settings">
          <mat-icon matListItemIcon>settings</mat-icon>
          {{ 'SIDENAV.SETTINGS' | translate }}
        </a>
        <a mat-list-item (click)="logout()" (click)="sidenav.close()">
          <mat-icon matListItemIcon>logout</mat-icon>
          {{ 'SIDENAV.LOGOUT' | translate }}
        </a>
      </mat-nav-list>
      <div class="app-version">{{ 'SIDENAV.VERSION' | translate }}</div>
    </div>
  </mat-sidenav>

  <mat-sidenav-content>
    <mat-toolbar color="primary">
      <div class="toolbar-header">
        <button mat-icon-button (click)="sidenav.toggle()">
          <mat-icon matListItemIcon>menu</mat-icon>
        </button>
        <span class="toolbar-title">{{ pageTitle() }}</span>
      </div>
    </mat-toolbar>

    <div class="shell-content">
      <router-outlet></router-outlet>
    </div>
  </mat-sidenav-content>
</mat-sidenav-container>
